module.exports = __webpack_public_path__ + "media/assets/projects_site_in_use-c2a61c05.jpg";